export var LOCATION_SELECT_PLACEHOLDER = 'Select a Location';